import { Capacitor } from '@capacitor/core';
import { marketingPageFor } from './marketing/routes';

// The public website (home, pricing, legal, activation request) is a small, separate bundle
// so visitors never download Firebase or the dashboard code. All other paths boot the app as before.
const root = document.getElementById('root')!;
const nativeApp = Capacitor.isNativePlatform() || window.location.protocol === 'capacitor:';
const page = nativeApp ? null : marketingPageFor(window.location.pathname);

if (page) void import('./marketing/client').then(module => module.mountMarketing(root, page));
else void import('./appEntry').then(module => module.mountApp(root));
